import { inject, Injectable } from '@angular/core';
import { ApiClient } from '@eng-ds/api-client';
import { Observable } from 'rxjs';
import {
	DatiUtente,
	SuperUserOption,
	UDDMenuItemsObject
} from './../models/super-user-options.model';

@Injectable()
export class SuperUserService {
	/**
	 * DI
	 */
	private apiClient = inject(ApiClient);

	get(): Observable<UDDMenuItemsObject> {
		return this.apiClient.request('getUDDMenuItems');
	}

	getOptions(): Observable<SuperUserOption> {
		return this.apiClient.request('ACC_6');
	}

	getDatiUtente(): Observable<DatiUtente> {
		return this.apiClient.request('HOME_7');
	}
}
